var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GmapCustomMarker',{attrs:{"marker":{ lat: _vm.latitude, lng: _vm.longitude }}},[_c('img',{attrs:{"src":require("@/assets/images/logo-recycoin.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }